<template>
  <div class="vouchersForm">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">{{ couponInfo.name }}</span>
    </div>
    <van-cell-group title="申请信息">
      <van-cell required title="领取人" @click="addRecipient">
        <template #right-icon>
          {{ dataForm.name }}
          <van-icon name="arrow" class="search-icon" />
        </template>
      </van-cell>
      <van-field
        v-model="dataForm.applyReason"
        required
        rows="2"
        autosize
        label="申请理由"
        type="textarea"
        placeholder="请输入申请理由"
        @change="changeDataForm"
      />
      <van-cell title="附件">
        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
        <template #right-icon>
          <van-uploader :after-read="afterRead">
            <van-icon name="plus" class="search-icon" />
          </van-uploader>
        </template>
      </van-cell>
      <van-cell v-for="(item, index) in dataForm.attachmentUrls" :key="index">
        <!-- 使用 title 插槽来自定义标题 -->
        <template #title>
          <div class="uploadList" @click="() => showImg(index)">
            <img class="thumbnail" :src="baseURL + item.url" alt="">
            <span class="nameArea">
              <span class="imgName">附件{{ index + 1 }}</span>
              <span class="imgSize">{{ item.size }} kb</span>
            </span>
          </div>
        </template>
        <template #right-icon>
          <van-icon name="close" @click="() => delUrl(index)" />
        </template>
      </van-cell>
      <van-cell required title="申请张数">
        <!-- 使用 title 插槽来自定义标题 -->
        <template #right-icon>
          <van-stepper v-model="dataForm.applyCount" min="1" @change="changeDataForm" />
        </template>
      </van-cell>
    </van-cell-group>
    <van-button
      :disabled="filterBtn()"
      class="sub_btn"
      type="info"
      @click="onConfirm"
    >提交卡券申请</van-button>
  </div>
</template>

<script>
import { Upload, applyCoupon } from '@/api/user';
import help from '@/common/help';
import config from '@/common/config';
import { ImagePreview } from 'vant';
export default {
  name: 'VoucherApplication',
  components: {
  },
  data() {
    return {
      couponInfo: {},
      loading: false,
      finished: false,
      baseURL: process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro,
      dataForm: {
        name: '',
        couponId: '',
        applyCount: '',
        receiptorId: '',
        applyReason: '',
        attachmentUrls: []
      },
      keys: [
        // 'couponId',
        'applyCount',
        'applyReason'
      ]
    };
  },
  // voucherApplicationForm
  computed: {
    voucherApplicationForm() {
      this.dataForm = this.$store.state.voucherApplicationForm;
      return this.$store.state.voucherApplicationForm;
    }
  },
  watch: {
    voucherApplicationForm() {}
  },
  created() {
    this.couponInfo = this.$store.state.couponInfo;
    const personalInfo = JSON.parse(localStorage.getItem('personalInfo') || '{}');
    if (this.$route.query.from === 'SelectStaff') {
      this.dataForm.name = this.$store.state.selectStaffInfo.name || personalInfo.name;
      this.dataForm.receiptorId = this.$store.state.selectStaffInfo.id;
    } else {
      this.dataForm.name = personalInfo.name;
    }
  },
  methods: {
    onConfirm() {
      // this.dataForm
      // this.$toast.loading({
      //   message: '提交中...',
      //   forbidClick: true,
      //   loadingType: 'spinner',
      //   duration: 0
      // });
      const urlList = [];
      this.dataForm.attachmentUrls.forEach(item => {
        urlList.push(item.url);
      });
      const data = {
        ...this.dataForm,
        attachmentUrls: urlList,
        couponId: this.couponInfo.id,
        receiptorId: this.$store.state.selectStaffId
      };
      applyCoupon(data).then(res => {
        if (res.code === 200) {
          this.$toast.clear();
          this.$router.push({ name: 'success', query: { from: 'voucherApplication' }});
          this.$store.dispatch('clearVoucherApplicationForm');
        } else {
          this.$toast.clear();
        }
      });
    },
    filterBtn() {
      return !help.checkForm(this.keys, this.dataForm);
    },
    changeDataForm() {
      this.$store.dispatch('setVoucherApplicationForm', { data: this.dataForm });
    },
    goBack() {
      this.$router.push({ name: 'couponList' });
      this.$store.dispatch('clearVoucherApplicationForm');
      this.$store.dispatch('setSelectStaffParentId', { id: '' });
    },
    addRecipient() {
      this.$router.push({ name: 'selectStaff', query: { title: '选择领取人', from: 'voucherApplication' }});
    },
    afterRead(e) { // 上传的会议资料
      const fromData = new FormData();
      fromData.append('file', e.file);
      fromData.append('checked', false);
      // this.$toast.loading({
      //   message: '上传中...',
      //   forbidClick: true,
      //   loadingType: 'spinner',
      //   duration: 0
      // });
      Upload(fromData).then(res => {
        const data = { size: (e.file.size / 1024).toFixed(2), url: res.data };
        this.dataForm.attachmentUrls.push(data);
        this.$toast.clear();
        this.changeDataForm();
      }).catch(_ => {
        setTimeout(() => { this.$toast.clear(); }, 3000);
      });
    },
    delUrl(idx) {
      this.dataForm.attachmentUrls = this.dataForm.attachmentUrls.filter((item, index) => {
        return index !== idx;
      });
      this.changeDataForm();
    },
    showImg(index) {
      const list = [];
      this.dataForm.attachmentUrls.forEach(item => {
        list.push(this.baseURL + item.url);
      });
      ImagePreview({ images: list, startPosition: index, closeable: true });
    }
  }
};
</script>

<style lang="less" scoped>
.change_val(@name, @px){
    @{name}: @px / 200.6 * 1rem;
}
.change_margin(@name, @top, @right){
    @{name}: @top / 200.6 * 1rem @right / 200.6 * 1rem;
}

.vouchersForm {

  .uploadList {
    display: flex;

    .thumbnail {
      .change_val(width, 80);
      .change_val(height, 80);
    }

    .imgArea {
      display: flex;
      align-items: center;

      img {
        width: 0.35rem;
      }
    }

    .nameArea {
      display: flex;
      flex-direction: column;
      .change_val(margin-left, 8);
      .imgName {
        color: rgba(0, 0, 0, 0.85);
        .change_val(font-size, 28);
        .change_val(line-height, 40);
      }

      .imgSize {
        color: rgba(0, 0, 0, 0.5);
        .change_val(font-size, 24);
        .change_val(line-height, 33);
      }
    }
  }
}

</style>
